import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32a8f9ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main tw-overflow-x-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_brandpattern = _resolveComponent("brandpattern")!
  const _component_backgroundComponent = _resolveComponent("backgroundComponent")!
  const _component_active_path_wrapper = _resolveComponent("active-path-wrapper")!
  const _component_AppBarLayout = _resolveComponent("AppBarLayout")!

  return (_openBlock(), _createBlock(_component_AppBarLayout, null, {
    default: _withCtx(({ activeHierarchy }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_brandpattern, { page: "APPBARLAYOUT" }),
        _createVNode(_component_backgroundComponent),
        _createVNode(_component_active_path_wrapper, {
          "active-hierarchy": activeHierarchy,
          "button-title": "Button",
          "is-button-enable": true
        }, null, 8, ["active-hierarchy"])
      ])
    ]),
    _: 1
  }))
}